import { APIService } from "./api";
import { API } from "@/lib/api";
import { AgreementCompany } from "@/types/agreementCompany";

export const AgreementCompanyService = new APIService<AgreementCompany>(
  API.AgreementCompanies,
);
export const fetchAgreementCompanyList = AgreementCompanyService.getList;
